/* global axios */
import ApiClient from '../ApiClient';

class CaptainAssistant extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
      },
    });
  }

  playground({ assistantId, messageContent, messageHistory }) {
    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
    });
  }

  getCustomTools(assistantId) {
    return axios.get(`${this.url}/${assistantId}/custom_tools`);
  }

  updateCustomTools(assistantId, customToolIds) {
    return axios.put(`${this.url}/${assistantId}/custom_tools`, {
      custom_tool_ids: customToolIds,
    });
  }
}

export default new CaptainAssistant();
